export const addNotifications = (notifications, count) => ({
  type: "ADD_NOTIFICATIONS",
  notifications,
  count,
});

export const showNotifications = ({ shouldShowNotificationsCount, count }) => ({
  type: "SHOW_NOTIFICATIONS",
  meta: {
    mixpanel: {
      event: "notifacations.open",
      props: {
        shouldShowNotificationsCount,
        count,
      },
    },
  },
});

export const setLastSeenAt = date => ({
  type: "SET_LAST_SEEN_AT",
  date,
});



// WEBPACK FOOTER //
// ./src/actions/notificationActions.js